<div class="flex flex-col">
  <espace-partenaire-header />
  <router-outlet></router-outlet>
</div>
